/*!
 * bootstrap-select v1.3.5
 * http://silviomoreto.github.io/bootstrap-select/
 *
 * Copyright 2013 bootstrap-select
 * Licensed under the MIT license
 */

!(function ($) {
    "use strict";

    $.expr[":"].icontains = function (obj, index, meta) {
        return $(obj).text().toUpperCase().indexOf(meta[3].toUpperCase()) >= 0;
    };

    var Selectpicker = function (element, options, e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.$element = $(element);
        this.$newElement = null;
        this.$button = null;
        this.$menu = null;

        //Merge defaults, options and data-attributes to make our options
        this.options = $.extend(
            {},
            $.fn.selectpicker.defaults,
            this.$element.data(),
            typeof options == "object" && options
        );
        //If we have no title yet, check the attribute 'title' (this is missed by jq as its not a data-attribute
        if (this.options.title == null) {
            this.options.title = this.$element.attr("title");
        }

        //Expose public methods
        this.val = Selectpicker.prototype.val;
        this.render = Selectpicker.prototype.render;
        this.refresh = Selectpicker.prototype.refresh;
        this.reloadOptions = Selectpicker.prototype.reloadOptions;
        this.valueChanged = Selectpicker.prototype.valueChanged;
        this.setStyle = Selectpicker.prototype.setStyle;
        this.selectAll = Selectpicker.prototype.selectAll;
        this.deselectAll = Selectpicker.prototype.deselectAll;
        this.init();
    };

    Selectpicker.prototype = {
        constructor: Selectpicker,

        init: function () {
            this.$element.hide();
            this.multiple = this.$element.prop("multiple");
            this.truncate = this.$element.attr("truncate");
            this.seperator = this.$element.attr("seperator");
            var id = this.$element.attr("id");
            this.$newElement = this.createView();
            this.$element.after(this.$newElement);
            var s = this;

            this.$menu = this.$newElement.find("> .dropdown-menu");
            this.$button = this.$newElement.find("> button");
            this.$searchbox = this.$newElement.find("input");
            this.$originalLis = this.$menu.find("li").clone(true);
            this.$originalLis.remove();

            if (id !== undefined) {
                var that = this;
                this.$button.attr("data-id", id);
                $('label[for="' + id + '"]').click(function (e) {
                    e.preventDefault();
                    that.$button.focus();
                });
            }

            this.checkDisabled();
            this.clickListener();
            this.liveSearchListener();
            this.render();
            this.liHeight();
            this.setStyle();
            this.setWidth();
            if (this.options.container) {
                this.selectPosition();
            }
            this.$menu.data("this", this);
            this.$newElement.data("this", this);
        },

        createDropdown: function () {
            //If we are multiple, then add the show-tick class by default
            var multiple = this.multiple ? " show-tick" : "";
            var header = this.options.header
                ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>' +
                  this.options.header +
                  "</div>"
                : "";
            var searchbox =
                this.options.liveSearch && this.$element.find("option").length > 0
                    ? '<div class="bootstrap-select-searchbox"><input style="font-size: 12px;padding: 2px 8px;height: 30px;" type="text" class="input-block-level form-control" placeholder="Type to search..." /></div>'
                    : "";
            var drop =
                "<div class='bootstrap-select" +
                multiple +
                "'>" +
                "<button type='button' class='bf-button white' data-toggle='dropdown'>" +
                "<div class='filter-option pull-left'></div>&nbsp;" +
                "<div class='caret'></div>" +
                "</button>" +
                "<div class='dropdown-menu open'" +
                (this.$element.find("option").length === 0 || this.options.addbutton
                    ? 'style="padding:5px 0 0 0;"'
                    : "") +
                ">" +
                header +
                searchbox +
                "<ul class='dropdown-menu inner' role='menu' style='overflow-x: hidden;'>" +
                "</ul>" +
                (this.options.addbutton
                    ? "<div style='padding: 8px;'><button " +
                      (this.$element.find("option").length > 0 ? "style='margin-top:5px;'" : "") +
                      " class='bs-add-button bf-button bf-button--small'>" +
                      this.options.addbuttontext +
                      "</button></div>"
                    : "") +
                "</div>" +
                "</div>";

            return $(drop);
        },

        createView: function () {
            var $drop = this.createDropdown();

            if ($(".bs-add-button", $drop).length > 0) {
                var that = this;
                $(".bs-add-button", $drop).click(function () {
                    if (that.options.addbuttoncallback) {
                        that.options.addbuttoncallback(that.options.addbuttonobj);
                    }
                });
            }

            var $li = this.createLi();
            $drop.find("ul").append($li);

            return $drop;
        },
        reloadLi: function () {
            //Remove all children.
            this.destroyLi();
            //Re build
            var $li = this.createLi();
            this.$menu.find("ul").append($li);
        },
        destroyLi: function () {
            this.$menu.find("li").remove();
        },

        createLi: function () {
            var that = this,
                _liA = [],
                _liHtml = "";

            this.$element.find("option").each(function () {
                var $this = $(this);

                //Get the class and text for the option
                var optionClass = $this.attr("class") || "";
                var inline = $this.attr("style") || "";
                var text = $this.data("content") ? $this.data("content") : $this.text();

                var subtext =
                    $this.data("subtext") !== undefined
                        ? '<small class="muted text-muted">' + $this.data("subtext") + "</small>"
                        : "";
                var icon =
                    $this.data("icon") !== undefined
                        ? '<i class="glyphicon ' + $this.data("icon") + '"></i> '
                        : "";
                if (icon !== "" && ($this.is(":disabled") || $this.parent().is(":disabled"))) {
                    icon = "<span>" + icon + "</span>";
                }

                if (!$this.data("content")) {
                    //Prepend any icon and append any subtext to the main text.
                    text = icon + '<span class="text">' + text + subtext + "</span>";
                }

                if (
                    that.options.hideDisabled &&
                    ($this.is(":disabled") || $this.parent().is(":disabled"))
                ) {
                    _liA.push('<a style="min-height: 0; padding: 0"></a>');
                } else if ($this.parent().is("optgroup") && $this.data("divider") !== true) {
                    if ($this.index() == 0) {
                        //Get the opt group label
                        var label = $this.parent().attr("label");
                        var labelSubtext =
                            $this.parent().data("subtext") !== undefined
                                ? '<small class="muted text-muted">' +
                                  $this.parent().data("subtext") +
                                  "</small>"
                                : "";
                        var labelIcon = $this.parent().data("icon")
                            ? '<i class="' + $this.parent().data("icon") + '"></i> '
                            : "";
                        label = labelIcon + '<span class="text">' + label + labelSubtext + "</span>";

                        if ($this[0].index != 0) {
                            _liA.push(
                                '<div class="div-contain"><div class="divider"></div></div>' +
                                    "<dt>" +
                                    label +
                                    "</dt>" +
                                    that.createA(text, "opt " + optionClass, inline)
                            );
                        } else {
                            _liA.push(
                                "<dt>" +
                                    label +
                                    "</dt>" +
                                    that.createA(text, "opt " + optionClass, inline)
                            );
                        }
                    } else {
                        _liA.push(that.createA(text, "opt " + optionClass, inline));
                    }
                } else if ($this.data("divider") === true) {
                    _liA.push('<div class="div-contain"><div class="divider"></div></div>');
                } else if ($(this).data("hidden") === true) {
                    _liA.push("");
                } else {
                    _liA.push(that.createA(text, optionClass, inline));
                }
            });

            if (_liA.length) {
                $.each(_liA, function (i, item) {
                    _liHtml += "<li rel=" + i + ">" + item + "</li>";
                });
            } else {
                _liHtml += "<span class='no-items'>No items...</span>";
            }

            //If we are not multiple, and we dont have a selected item, and we dont have a title, select the first element so something is set in the button
            if (
                !this.multiple &&
                this.$element.find("option:selected").length == 0 &&
                !this.options.title
            ) {
                this.$element.find("option").eq(0).prop("selected", true).attr("selected", "selected");
            }

            return $(_liHtml);
        },

        createA: function (text, classes, inline) {
            var small = this.options.style && this.options.style.indexOf("small-text") != -1;
            return (
                '<a tabindex="0" class="' +
                classes +
                '" style="' +
                (small ? "padding: 3px 9px;font-size:12px;" : "") +
                inline +
                '">' +
                text +
                '<i class="bf-icon bf-icon-checkmark check-mark"></i>' +
                "</a>"
            );
        },

        render: function () {
            this.$options = this.$element.find("option");

            var that = this;

            if (this.multiple) {
                var options = this.$element[0].querySelectorAll("option");
                for (var i = 0; i < options.length; i++) {
                    that.setDisabled(
                        i,
                        $(options[i]).is(":disabled") || $(options[i]).parent().is(":disabled")
                    );
                    that.setSelected(i, $(options[i]).is(":selected"));
                }
            } else {
                var options = this.$element[0].querySelectorAll("option");
                for (var i = 0; i < options.length; i++) {
                    that.setDisabled(
                        i,
                        $(options[i]).is(":disabled") || $(options[i]).parent().is(":disabled")
                    );
                }
            }

            this.tabIndex();
            var selectedItems = [];

            options = this.$element[0].querySelectorAll("option:checked");

            if (this.truncate && options.length > this.truncate) {
                var removeText = true;
                this.seperator = " ";
            } else {
                var removeText = false;
                if (this.seperator == " ") {
                    this.seperator = this.$element.attr("seperator");
                }
            }

            for (var i = 0; i < options.length; i++) {
                var item = "";
                var $this = $(options[i]);
                var icon =
                    $this.data("icon") && that.options.showIcon
                        ? '<i class="glyphicon ' + $this.data("icon") + '"></i> '
                        : "";
                var subtext;
                if (that.options.showSubtext && $this.attr("data-subtext") && !that.multiple) {
                    subtext = ' <small class="muted text-muted">' + $this.data("subtext") + "</small>";
                } else {
                    subtext = "";
                }
                if ($this.data("content") && that.options.showContent) {
                    item = $this.data("content");
                } else if ($this.attr("title") != undefined) {
                    item = $this.attr("title");
                } else if (removeText) {
                    item = icon + $this.text().slice(0, $this.text().lastIndexOf(">")) + ">" + subtext;
                } else {
                    item = icon + $this.text() + subtext;
                }
                selectedItems.push(item);
            }

            //Fixes issue in IE10 occurring when no default option is selected and at least one option is disabled
            //Convert all the values into a comma delimited string

            var title = !this.multiple
                ? selectedItems[0]
                : selectedItems.join(this.seperator ? " {0} ".format(this.seperator) : ", ");

            //If this is multi select, and the selectText type is count, the show 1 of 2 selected etc..
            if (this.multiple && this.options.selectedTextFormat.indexOf("count") > -1) {
                var max = this.options.selectedTextFormat.split(">");
                var notDisabled = this.options.hideDisabled ? ":not([disabled])" : "";
                if (
                    (max.length > 1 && selectedItems.length > max[1]) ||
                    (max.length == 1 && selectedItems.length >= 2)
                ) {
                    title = this.options.countSelectedText
                        .replace("{0}", selectedItems.length)
                        .replace(
                            "{1}",
                            this.$element.find(
                                'option:not([data-divider="true"]):not([data-hidden="true"])' +
                                    notDisabled
                            ).length
                        );
                }
            }

            //If we dont have a title, then use the default, or if nothing is set at all, use the not selected text
            if (!title) {
                title =
                    this.options.title != undefined
                        ? this.options.title
                        : this.options.noneSelectedText;
            }

            this.$newElement.find(".filter-option").html(title);
        },

        setStyle: function (style, status) {
            if (this.$element.attr("class")) {
                this.$newElement.addClass(
                    this.$element.attr("class").replace(/selectpicker|mobile-device/gi, "")
                );
            }

            var buttonClass = style ? style : this.options.style;

            if (status == "add") {
                this.$button.addClass(buttonClass);
            } else if (status == "remove") {
                this.$button.removeClass(buttonClass);
            } else {
                this.$button.removeClass(this.options.style);
                this.$button.addClass(buttonClass);
            }
        },

        liHeight: function () {
            var selectClone = this.$newElement.clone();
            selectClone.appendTo("body");
            var $menuClone = selectClone.addClass("open").find("> .dropdown-menu");
            var liHeight = $menuClone.find("li > a").outerHeight();
            var headerHeight = this.options.header
                ? $menuClone.find(".popover-title").outerHeight()
                : 0;
            var searchHeight = this.options.liveSearch
                ? $menuClone.find(".bootstrap-select-searchbox").outerHeight()
                : 0;
            selectClone.remove();
            this.$newElement
                .data("liHeight", liHeight)
                .data("headerHeight", headerHeight)
                .data("searchHeight", searchHeight);
        },

        setSize: function () {
            var that = this,
                menu = this.$menu,
                menuInner = menu.find(".inner"),
                selectHeight = this.$newElement.outerHeight(),
                liHeight = this.$newElement.data("liHeight"),
                headerHeight = this.$newElement.data("headerHeight"),
                searchHeight = this.$newElement.data("searchHeight"),
                divHeight = menu.find("li .divider").outerHeight(true) || 32,
                menuPadding =
                    parseInt(menu.css("padding-top")) +
                    parseInt(menu.css("padding-bottom")) +
                    parseInt(menu.css("border-top-width")) +
                    parseInt(menu.css("border-bottom-width")),
                notDisabled = this.options.hideDisabled ? ":not(.disabled)" : "",
                $window = $(window),
                menuExtras =
                    menuPadding +
                    parseInt(menu.css("margin-top")) +
                    parseInt(menu.css("margin-bottom")) +
                    2,
                menuHeight,
                selectOffsetTop,
                selectOffsetBot,
                posVert = function () {
                    selectOffsetTop = that.$newElement.offset().top - $window.scrollTop();
                    selectOffsetBot = $window.height() - selectOffsetTop - selectHeight;
                };
            posVert();

            if (this.options.header) menu.css("padding-top", 0);

            if (this.options.size == "auto") {
                var getSize = function () {
                    var minHeight;
                    posVert();
                    menuHeight = selectOffsetBot - menuExtras;

                    that.$newElement.toggleClass(
                        "dropup",
                        selectOffsetTop > selectOffsetBot &&
                            menuHeight - menuExtras < menu.height() &&
                            that.options.dropupAuto
                    );
                    if (that.$newElement.hasClass("dropup")) {
                        menuHeight = selectOffsetTop - menuExtras;
                    }
                    if (menu.find("li").length + menu.find("dt").length > 3) {
                        minHeight = liHeight * 3 + menuExtras - 2;
                    } else {
                        minHeight = 0;
                    }
                    //menuHeight = 100;
                    menu.css({
                        "max-height": menuHeight + "px",
                        overflow: "hidden",
                        "overflow-y": "auto",
                        "min-height": minHeight + "px"
                    });
                    //menuInner.css({ 'max-height': menuHeight - headerHeight - searchHeight - menuPadding + 'px', 'overflow-y': 'auto', 'min-height': minHeight - menuPadding + 'px' });
                };
                getSize();
                $(window).resize(getSize);
                $(window).scroll(getSize);
            } else if (
                this.options.size &&
                this.options.size != "auto" &&
                menu.find("li" + notDisabled).length > this.options.size
            ) {
                var optIndex = menu
                    .find("li" + notDisabled + " > *")
                    .filter(":not(.div-contain)")
                    .slice(0, this.options.size)
                    .last()
                    .parent()
                    .index();
                var divLength = menu
                    .find("li")
                    .slice(0, optIndex + 1)
                    .find(".div-contain").length;
                menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding;
                this.$newElement.toggleClass(
                    "dropup",
                    selectOffsetTop > selectOffsetBot &&
                        menuHeight < menu.height() &&
                        this.options.dropupAuto
                );
                // -this.options.size to compensate for each items border
                menu.css({
                    "max-height": menuHeight + headerHeight + searchHeight - this.options.size + "px",
                    overflow: "hidden",
                    "overflow-y": "auto"
                });
                menuInner.css({
                    "max-height": menuHeight - menuPadding - this.options.size + "px",
                    "overflow-y": "auto"
                });
            }
        },

        setWidth: function () {
            var self = this;

            if (this.options.width == "auto") {
                this.$menu.css("min-width", "0");

                // Get correct width if element hidden
                var selectClone = this.$newElement.clone().appendTo("body");
                var ulWidth = selectClone.find("> .dropdown-menu").css("width");
                selectClone.find("> .dropdown-menu").css({ display: "block", opacity: "0" });
                selectClone.find("> .dropdown-menu .text").each(function (i) {
                    if ($(this).outerWidth() > $(this).parent().outerWidth()) {
                        var txt = self.$newElement.find("> .dropdown-menu .text").eq(i).text();
                        self.$newElement.find("> .dropdown-menu a").eq(i).attr("title", txt);
                    }
                });
                selectClone.remove();

                this.$newElement.css("width", ulWidth);
            } else if (this.options.width == "fit") {
                // Remove inline min-width so width can be changed from 'auto'
                this.$menu.css("min-width", "");
                this.$newElement.css("width", "").addClass("fit-width");
            } else if (this.options.width) {
                // Remove inline min-width so width can be changed from 'auto'

                var selectClone = this.$newElement.clone().appendTo("body");
                selectClone.find("> .dropdown-menu").css({ display: "block", opacity: "0" });
                selectClone.find("> .dropdown-menu .text").each(function (i) {
                    if ($(this).outerWidth() > $(this).parent().outerWidth()) {
                        var txt = self.$newElement.find("> .dropdown-menu .text").eq(i).text();
                        self.$newElement.find("> .dropdown-menu a").eq(i).attr("title", txt);
                    }
                });
                selectClone.remove();

                this.$menu.css("min-width", "");
                this.$newElement.css("width", this.options.width);
            } else {
                // Remove inline min-width/width so width can be changed
                this.$menu.css("min-width", "");
                this.$newElement.css("width", "");
            }
            // Remove fit-width class if width is changed programmatically
            if (this.$newElement.hasClass("fit-width") && this.options.width !== "fit") {
                this.$newElement.removeClass("fit-width");
            }
        },

        selectPosition: function () {
            var that = this,
                drop = "<div />",
                $drop = $(drop),
                pos,
                actualHeight,
                getPlacement = function ($element) {
                    $drop
                        .addClass($element.attr("class"))
                        .toggleClass("dropup", $element.hasClass("dropup"));
                    pos = $element.position();
                    actualHeight = $element.hasClass("dropup") ? 0 : $element[0].offsetHeight;
                    $drop.css({
                        top: pos.top + actualHeight,
                        left: pos.left,
                        width: $element[0].offsetWidth,
                        position: "absolute"
                    });
                };
            this.$newElement.on("click", function () {
                getPlacement($(this));
                $drop.appendTo(that.options.container);
                $drop.toggleClass("open", !$(this).hasClass("open"));
                $drop.append(that.$menu);
                //that.doSearch('');
            });
            $(window).resize(function () {
                getPlacement(that.$newElement);
            });
            $(window).on("scroll", function () {
                getPlacement(that.$newElement);
            });
            $("html").on("click", function (e) {
                if ($(e.target).closest(that.$newElement).length < 1) {
                    $drop.removeClass("open");
                }
            });
        },

        mobile: function () {
            this.$element.addClass("mobile-device").appendTo(this.$newElement);
            if (this.options.container) this.$menu.hide();
        },
        reloadOptions: function () {
            this.refresh();
        },
        valueChanged: function () {
            this.render();
        },
        refresh: function () {
            this.reloadLi();
            this.render();
            this.setWidth();
            this.setStyle();
            this.checkDisabled();
            this.liHeight();
            this.clusterize.refresh();
        },
        update: function () {
            this.reloadLi();
            this.setWidth();
            this.setStyle();
            this.checkDisabled();
            this.liHeight();
        },
        setSelected: function (index, selected) {
            this.$menu
                .find(".dropdown-menu.inner li[rel={0}]".format(index))
                .toggleClass("selected", selected);
            this.$originalLis.filter("[rel={0}]".format(index)).toggleClass("selected", selected);
        },
        setDisabled: function (index, disabled) {
            if (disabled) {
                this.$originalLis
                    .eq(index)
                    .addClass("disabled")
                    .find("a")
                    .attr("href", "#")
                    .attr("tabindex", -1);
                this.$menu
                    .find(".dropdown-menu.inner li")
                    .eq(index)
                    .addClass("disabled")
                    .find("a")
                    .attr("href", "#")
                    .attr("tabindex", -1);
            } else {
                this.$originalLis
                    .eq(index)
                    .removeClass("disabled")
                    .find("a")
                    .removeAttr("href")
                    .attr("tabindex", 0);
                this.$menu
                    .find(".dropdown-menu.inner li")
                    .eq(index)
                    .removeClass("disabled")
                    .find("a")
                    .removeAttr("href")
                    .attr("tabindex", 0);
            }
        },
        isDisabled: function () {
            return this.$element.is(":disabled");
        },
        checkDisabled: function () {
            var that = this;

            if (this.isDisabled()) {
                this.$button.addClass("disabled").attr("tabindex", -1);
            } else {
                if (this.$button.hasClass("disabled")) {
                    this.$button.removeClass("disabled");
                }

                if (this.$button.attr("tabindex") == -1) {
                    if (!this.$element.data("tabindex")) this.$button.removeAttr("tabindex");
                }
            }

            this.$button.click(function () {
                return !that.isDisabled();
            });
        },

        tabIndex: function () {
            if (this.$element.is("[tabindex]")) {
                this.$element.data("tabindex", this.$element.attr("tabindex"));
                this.$button.attr("tabindex", this.$element.data("tabindex"));
            }
        },

        clickListener: function () {
            var that = this;

            $("body").on("touchstart.dropdown", ".dropdown-menu", function (e) {
                e.stopPropagation();
            });

            this.$newElement.on("click", function () {
                $(".bootstrap-select-searchbox > input", that.$drop).val("");
                //that.doSearch();
                that.setSize();
            });

            this.$menu.on("click", "li a", function (e) {
                var clickedIndex = $(this).parent().index();
                var prevValue = that.$element.val();

                //Dont close on multi choice menu
                if (that.multiple) {
                    e.stopPropagation();
                }

                e.preventDefault();

                //Dont run if we have been disabled
                if (!that.isDisabled() && !$(this).parent().hasClass("disabled")) {
                    var $options = that.$element.find("option");
                    var $option = $options.eq(parseInt($(this).parent().attr("rel")));

                    //Deselect all others if not multi select box
                    if (!that.multiple) {
                        $(".bootstrap-select-searchbox > input", that.$drop).val("");
                        $(".bootstrap-select-searchbox > input", that.$drop).trigger("input");
                        $options.prop("selected", false);
                        $option.prop("selected", true);
                    }
                    //Else toggle the one we have chosen if we are multi select.
                    else {
                        var state = $option.prop("selected");
                        $option.prop("selected", !state);
                    }

                    that.$button.focus();

                    // Trigger select 'change'
                    if (prevValue != that.$element.val()) {
                        that.$element.change();
                    }
                }
            });

            this.$menu.on(
                "click",
                "li.disabled a, li dt, li .div-contain, h3.popover-title",
                function (e) {
                    if (e.target == this) {
                        e.preventDefault();
                        e.stopPropagation();
                        that.$button.focus();
                    }
                }
            );

            this.$searchbox.on("click", function (e) {
                e.stopPropagation();
            });
        },
        doSearch: function (query) {
            var that = this;

            if (that.clusterize) that.clusterize.destroy();

            var lis = that.$originalLis.clone(true);

            if (query) {
                lis = lis.filter(function () {
                    return $(this).text().toLowerCase().indexOf(query.toLowerCase()) !== -1;
                });
            }

            if (!lis.length) {
                lis = $("<span class='no-items'>No items found</span>");
            }

            that.$currentLis = lis;

            that.$menu.find(".dropdown-menu.inner").empty();
            that.$menu.find(".dropdown-menu.inner").append(lis);
            that.clusterize = new Clusterize({
                scrollElem: that.$menu[0],
                contentElem: that.$menu.find(".dropdown-menu.inner")[0]
            });
        },
        liveSearchListener: function () {
            var that = this;
            this.$newElement.on("click.dropdown.data-api", function () {
                if (that.options.liveSearch) {
                    setTimeout(function () {
                        that.$searchbox.focus();
                    }, 10);
                }
            });

            this.$searchbox.on(
                "keyup",
                _.debounce(function () {
                    that.doSearch(that.$searchbox.val());
                }, 250)
            );
        },

        val: function (value) {
            if (value != undefined) {
                this.$element.val(value);

                this.$element.change();
                return this.$element;
            } else {
                return this.$element.val();
            }
        },

        selectAll: function () {
            this.$element.find("option").prop("selected", true).attr("selected", "selected");
            this.render();
        },

        deselectAll: function () {
            this.$element.find("option").prop("selected", false).removeAttr("selected");
            this.render();
        },

        keydown: function (e) {
            var $this, $items, $parent, index, next, first, last, prev, nextPrev, that;

            $this = $(this);

            $parent = $this.parent();

            that = $parent.data("this");

            // Fuck bootstrap select
            if (!that) {
                return;
            }

            if (that && that.options.container) $parent = that.$menu;

            $items = $("[role=menu] li:not(.divider):visible a", $parent);

            var keyCodeMap = {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9"
            };

            if (!$items.length && that && that.$button) {
                that.$button.click();
                that.$searchbox.val(keyCodeMap[e.keyCode]);
                that.$searchbox.trigger("input");
                return;
            }

            if (/(38|40)/.test(e.keyCode)) {
                index = $items.index($items.filter(":focus"));
                first = $items.parent(":not(.disabled)").first().index();
                last = $items.parent(":not(.disabled)").last().index();
                next = $items.eq(index).parent().nextAll(":not(.disabled)").eq(0).index();
                prev = $items.eq(index).parent().prevAll(":not(.disabled)").eq(0).index();
                nextPrev = $items.eq(next).parent().prevAll(":not(.disabled)").eq(0).index();

                if (e.keyCode == 38) {
                    if (index != nextPrev && index > prev) index = prev;
                    if (index < first) index = first;
                }

                if (e.keyCode == 40) {
                    if (index != nextPrev && index < next) index = next;
                    if (index > last) index = last;
                    if (index == -1) index = 0;
                }

                $items.eq(index).focus();
            } else {
                var keyIndex = [];

                $items.each(function () {
                    if ($(this).parent().is(":not(.disabled)")) {
                        if (
                            $.trim($(this).text().toLowerCase()).substring(0, 1) ==
                            keyCodeMap[e.keyCode]
                        ) {
                            keyIndex.push($(this).parent().index());
                        }
                    }
                });

                var count = $(document).data("keycount");
                count++;
                $(document).data("keycount", count);

                var prevKey = $.trim($(":focus").text().toLowerCase()).substring(0, 1);

                if (prevKey != keyCodeMap[e.keyCode]) {
                    count = 1;
                    $(document).data("keycount", count);
                } else if (count >= keyIndex.length) {
                    $(document).data("keycount", 0);
                }

                $items.eq(keyIndex[count - 1]).focus();
            }

            // select focused option if "Enter" or "Spacebar" are pressed
            if (/(13|32)/.test(e.keyCode)) {
                e.preventDefault();
                $(":focus").click();
                $(document).data("keycount", 0);
            } else {
            }
        },

        hide: function () {
            this.$newElement.hide();
        },

        show: function () {
            this.$newElement.show();
        },

        destroy: function () {
            this.$newElement.remove();
            this.$element
                .off(".bs.select")
                .removeData("selectpicker")
                .removeClass("bs-select-hidden selectpicker");
            this.$menu.remove();
            this.$button.remove();
        }
    };

    $.fn.selectpicker = function (option, event) {
        //get the args of the outer function..
        var args = arguments;
        var value;
        var chain = this.each(function () {
            if ($(this).is("select")) {
                var $this = $(this),
                    data = $this.data("selectpicker"),
                    options = typeof option == "object" && option;

                if (!data) {
                    $this.data("selectpicker", (data = new Selectpicker(this, options, event)));
                } else if (options) {
                    for (var i in options) {
                        data.options[i] = options[i];
                    }
                }

                if (typeof option == "string") {
                    //Copy the value of option, as once we shift the arguments
                    //it also shifts the value of option.
                    var property = option;
                    if (data[property] instanceof Function) {
                        [].shift.apply(args);
                        value = data[property].apply(data, args);
                    } else {
                        value = data.options[property];
                    }
                }
            }
        });
        if (value != undefined) {
            return value;
        } else {
            return chain;
        }
    };

    $.fn.selectpicker.defaults = {
        style: "",
        size: "auto",
        title: null,
        selectedTextFormat: "values",
        noneSelectedText: "Nothing selected",
        countSelectedText: "{0} of {1} selected",
        width: false,
        container: false,
        hideDisabled: false,
        showSubtext: false,
        showIcon: true,
        showContent: true,
        dropupAuto: true,
        header: false,
        liveSearch: false
    };

    $(document)
        .data("keycount", 0)
        .on("keydown", "[data-toggle=dropdown], [role=menu]", Selectpicker.prototype.keydown);
})(window.jQuery);
